export default "__VITE_ASSET__67dfaa39__"